module.exports = __webpack_public_path__ + "static/family-34c01ae3370559d86b5f8c3f71e77b95.svg";